import { AlertTriangle } from 'react-feather';

import { Button } from '~ui/base/button';
import { Typography } from '~ui/base/typography';

interface SearchErrorProps {
  message?: string;
  onRetry: () => void;
}

/** Error state — destructive-container surface, plain-language message. */
function SearchError({ message, onRetry }: SearchErrorProps) {
  return (
    <div className="flex items-start gap-x-4 rounded-[1.25rem] bg-destructive-container p-6 text-destructive-container-foreground">
      <AlertTriangle aria-hidden className="mt-0.5 size-5 shrink-0" />
      <div className="flex flex-1 flex-col gap-y-2">
        <Typography variant="subtitle-sm" as="h2">
          Something went wrong
        </Typography>
        <Typography variant="body-md" as="p">
          {message ?? "We couldn't reach the search service. Please try again."}
        </Typography>
        <div>
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}

export { SearchError };
